import { UUID } from "../generic/uuid";

import { createRegionDtoFromAdminRegionModel, RegionModel } from "./region";
import {
  createWineTypeDtoFromAdminWineTypeModel,
  WineTypeModel,
} from "./wineType";
import { createWineryDtoFromAdminWineryModel, WineryModel } from "./winery";
import { WineDto } from "@vini-wine/core-dtos";

export interface WineModel extends UUID {
  // available includes
  region?: RegionModel;
  wineType?: WineTypeModel;
  winery?: WineryModel;
  mappedItems?: any;

  // transform
  name: string;
}

export const createWineDtoFromAdminWineModel = (wine: WineModel): WineDto => {
  return {
    uuid: wine.uuid,
    name: wine.name,
    wineType: wine.wineType
      ? createWineTypeDtoFromAdminWineTypeModel(wine.wineType)
      : undefined,
    region: wine.region
      ? createRegionDtoFromAdminRegionModel(wine.region)
      : undefined,
    winery: wine.winery
      ? createWineryDtoFromAdminWineryModel(wine.winery)
      : undefined,
  };
};
